import { render } from "./NTooltip.vue?vue&type=template&id=ecbe71cc&ts=true"
import script from "./NTooltip.vue?vue&type=script&lang=ts"
export * from "./NTooltip.vue?vue&type=script&lang=ts"

import "./NTooltip.vue?vue&type=style&index=0&id=ecbe71cc&lang=stylus"

import exportComponent from "/tmp/ffsecurity-ui/packages/v2/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__